<template>
  <div>
    <div class="page page__list" v-if="!isChange">
      <search-bar
        @search="onSearch"
        name="pj_code,pj_dename"
        placeholder="输入项目单号、项目名称进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.pj_id"
          :to="'/plm/proj/' + item.pj_id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.pj_code }}</p>
            <p class="list-item-muted">{{ item.pj_dename }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.de_emname }}&nbsp;{{ item.pj_product_type }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.pj_status != '已审核' }"
              >{{ item.pj_status }}</span
            >
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}单</label>
      </div>
      <add-button to="/plm/proj_edit" />
    </div>
    <div class="page page__list" v-if="isChange">
      <search-bar
        @search="onSearch"
        name="pc_code,pj_code"
        placeholder="输入变更单号、项目单号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/plm/proj_change/' + item.id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.pc_code }}</p>
            <p class="list-item-muted">{{ item.pj_code }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.pj_dename }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.pc_status != '已审核' }"
            >
              {{ item.pc_status }}
            </span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}条</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton,
  },
  mixins: [list],
  data() {
    
    const me = this,
      beforeChange = me.beforeFilterChange;
    return {
      isChange: false,
      listUrl: "/api/plm/proj/list",
      filters: [
        {
          type: "date",
          name: "plm_proj.createTime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "pj_status='未审核'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "pj_status='已审核'",
            },
            {
              value: 3,
              label: "待变更",
              condition: "pc_statuscode='SUBMITTED'",
            },
            {
              value: 4,
              label: "已变更",
              condition: "pc_statuscode='AUDITED'",
            },
          ],
        },
      ],
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
   
      let isChange = filter.value > 2;
      this.listUrl = isChange
        ? "/api/plm/projchange/list"
        : "/api/plm/proj/list";
      this.filters[0].name = isChange ? "plm_proj_change.createTime" : "plm_proj.createTime";
      this.isChange = isChange ? true : false;
      filterBar.initConfig();
      next();
    },
  },
};
</script>